import React from "react";
import { connect } from "react-redux";
import { Text } from "react-internationalization";
import ContactUs from "./Contact";
const RetireeText = (props) => {
  if (props.productCategory === "RETIREE") {
    return (
      <React.Fragment>
        <br />
        <div 
        // style={{ textAlign: "left" }}
        class="ml13px"
        >
          <strong>
            <Text id="header.importantInstruction" />
          </strong>
        </div>
        <br />
        <div 
        // style={{ textAlign: "left" }}
        class="ml13px"
        >
          <Text id="header.importantInstructionPara" />

          <br />
          <br />
          <p 
          // style={{ textAlign: "left" }}
          >
            <Text id="header.importantInstructionNote" />
          </p>
        </div>
        <ContactUs productCategory={props.productCategory} />
        <br/>
      </React.Fragment>
    );
  } else {
    return null;
  }
};

const mapStateToProps = (state) => {
  return {
    selectedPlan: state.login.selectedPlanName
      ? state.login.selectedPlanName
      : state.webApp.preEnrollInfo?.planName,
    productCategory: state.login.productCategory
      ? state.login.productCategory
      : state.webApp.preEnrollInfo?.productCategory,
    year: state.webApp.year.planYear,
    lang: state.webApp.language,
  };
};

export default connect(mapStateToProps)(RetireeText);
